import React from "react";

export const Footer = () => {
  return (
    <div className="footer">
      <footer
        class="text-light"
      >
        <div class="text-center">
          Made with ❤
          <a
            class="text-reset fw-bold text-decoration-none"
            target="_blank"
            href="https://twitter.com/mahek_ramdasani"
          >&nbsp;
            Mahek Ramdasani
          </a>
        </div>
      </footer>
    </div>
  );
};
